export const ShoppingCartTooltipEnums = {
    SGR: 'SGR',
    Calamityfund: 'Calamiteitenfonds',
    LocalFee: 'Te plaatse te betalen',
    Betalen: 'Ter plaastse te betalen',
    Downpayment: 'Downpayment',
    RestToPay: 'Rest to pay'
}
